import { ModalWrap } from '../modal-wrap';
import React, { useState } from 'react';
import './index.scss';
import warnImage from '../../assets/images/warn-yellow.png';
import getFormatMessage from '../../locales/get-format-message';

interface IProps {
  readonly onClose: () => void;
  readonly title: string;
  readonly description: React.ReactNode | string;
  readonly okText: string;
  readonly onSubmit: () => Promise<boolean>;
  readonly failedConfig: {
    readonly description: React.ReactNode | string;
    readonly title: string;
  };
}

export const DoubleModal = (props: IProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [failed, setFailed] = useState<boolean>(false);

  const onOk = async () => {
    setLoading(true);
    const res = await props.onSubmit();
    if (!res) {
      setFailed(true);
    }
    setLoading(false);
    return res;
  };

  const renderTitle = () => {
    return (
      <>
        <p className="fail-title">
          <img
            src={warnImage}
            alt="Warning"
            style={{ marginRight: '10px', marginTop: '-2px' }}
          />
          <span>{props.title}</span>
        </p>
      </>
    );
  };

  const renderModal = () => {
    return (
      <ModalWrap
        width="480px"
        onOk={onOk}
        onClose={props.onClose}
        title={renderTitle()}
        className="delete-modal delete-dialog"
        oKText={props.okText}
        okButtonProps={{
          danger: true,
        }}
        loading={loading}
        cancelText={getFormatMessage('cancel')}
      >
        <div className="delete-text remove-text">{props.description}</div>
      </ModalWrap>
    );
  };

  const renderFailedModal = () => {
    return (
      <ModalWrap
        width="480px"
        onOk={onOk}
        onClose={props.onClose}
        title={
          <p className="fail-title">
            <img
              src={warnImage}
              alt="Warning"
              style={{ marginRight: '10px', marginTop: '-2px' }}
            />
            <span>{props.failedConfig.title}</span>
          </p>
        }
        className="delete-modal delete-dialog"
        cancelText={getFormatMessage('cancel')}
      >
        <div className="delete-text remove-text">
          {props.failedConfig.description}
        </div>
      </ModalWrap>
    );
  };

  return failed ? renderFailedModal() : renderModal();
};
